/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {FC, useEffect, useState} from 'react';
import {Image, Platform, Text, TouchableOpacity, View} from 'react-native';
import {buttonsStyles} from '../../Button/boutonStyle';
import {FilePickerWeb} from '../FilePicker/FilePickerWeb';
import {formsStyles} from '../formStyles';
import ImagePicker from '../ImagePicker';
import styles from '../styles';

interface InputImageViewerProps {
  label?: string;
  name?: string;
  error?: string;
  required?: boolean;
  showError?: boolean;
  value?: any;
  onChange: (name: string, value: string, isFired: boolean) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  type?: string;
  maxLength?: number;
  isEditable?: boolean;
}

export const InputImageViewer: FC<InputImageViewerProps> = props => {
  const {
    required = false,
    value = '',
    onChange,
    name = '',
    error = '',
    showError = false,
  } = props;
  const handleChange = (name: string, value: string) => {
    if (value && value.length > 0) {
      onChange(name, value, true);
    } else {
      onChange(name, 'INVALID INPUT', true);
    }
  };
  const handleChangeMobile = (name: string, value: string) => {
    onChange(name, value, true);
  };

  const [errorToDisplay, setErrorToDisplay] = useState(error);

  const [picture, setPicture] = useState<any>();

  useEffect(() => {
    if (Platform.OS === 'web' && value !== '' && value !== 'INVALID INPUT') {
      setPicture(URL.createObjectURL(value[0]));
    } else if (
      Platform.OS !== 'web' &&
      value !== '' &&
      value !== 'INVALID INPUT'
    ) {
      setPicture({uri: value.uri});
    }
  }, [value]);

  useEffect(() => {
    setTimeout(() => {
      setErrorToDisplay(error);
    }, 150);
  }, [error]);
  return (
    <View style={styles.container}>
      <View>
        <View style={buttonsStyles.displayCenter}>
          <View
            style={[
              buttonsStyles.displayHorizontal,
              buttonsStyles.displaySpacedBtween,
            ]}>
            <Image
              source={
                value === '' || value === 'INVALID INPUT'
                  ? require('../../../../ressources/images/dark-user_ph.png')
                  : picture
              }
              style={formsStyles.profilInsc}
            />
            {Platform.OS === 'web' && (
              <View>
                <TouchableOpacity>
                  <FilePickerWeb
                    callback={(file: any) => handleChange(name, file)}
                    type="fileLabeled"
                  />
                </TouchableOpacity>
                {required && showError && errorToDisplay !== '' && (
                  <Text style={styles.textError}>{errorToDisplay}</Text>
                )}
              </View>
            )}
            {Platform.OS !== 'web' && (
              <View>
                <ImagePicker
                  name="image"
                  type="type_text_photo"
                  callback={(file: any) => handleChangeMobile(name, file)}
                />
                {required && showError && errorToDisplay !== '' && (
                  <Text style={styles.textError}>{errorToDisplay}</Text>
                )}
              </View>
            )}
          </View>
        </View>
      </View>
    </View>
  );
};
